export const API_BASE_URL_DEV = 'http://localhost:8080/'
export const API_BASE_URL_PROD = 'https://api.danielajanjic.ch/'



// WEBPACK FOOTER //
// ./src/front/config.js